import React from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CookieConsent } from './components/CookieConsent';
import { AnnouncementBar } from './components/AnnouncementBar';
import { useAnalytics } from './hooks/useAnalytics';
interface AppProps {
  children: React.ReactNode;
}
export function App({
  children
}: AppProps) {
  // Track page views automatically on route changes
  useAnalytics();
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      {/* Google Tag Manager (noscript) fallback */}
      <noscript data-id="element-1">
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5V2WHRG3" height="0" width="0" style={{
        display: 'none',
        visibility: 'hidden'
      }} data-id="element-2" />
      </noscript>
      <AnnouncementBar data-id="element-3" />
      <Header data-id="element-4" />
      <main data-id="element-5">{children}</main>
      <Footer data-id="element-6" />
      <CookieConsent data-id="element-7" />
    </div>;
}